export default "__VITE_ASSET__DK3XSh2R__"